<template>
  <Loader v-if="isLoading"></Loader>
  <b-row v-else-if="$route.name === 'EXCMCaseCreate' && !isLoading">
    <b-col cols="12">
      <b-row class="mb-1">
        <b-col>
          <router-link :to="{ name: 'EXCMCaseList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <EXCMCaseForm
              :isContractorUserDataDisabled="Boolean(idContractor)"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col>
      <EXCMCaseForm
        :isContractorUserDataDisabled="Boolean(idContractor)"
        :user-data-firms="userDataFirms"
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import EXCMCaseForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('excmcase/create')
export default {
  components: {
    EXCMCaseForm,
    Loader
  },
  props: ['userDataFirms', 'idContractor', 'idRelatedCorrespondenceMessage'],
  data () {
    return {
      item: {
        caseTags: [],
        customFields: [],
        caseProblems: [],
        agreement: null,
        idDevice: null,
        sla: null,
        deadlineDate: null,
        contractorUserData: this.idContractor ? this.idContractor : null,
        idRelatedCorrespondenceMessage: this.idRelatedCorrespondenceMessage ? this.idRelatedCorrespondenceMessage : null
      }
    }
  },
  beforeCreate () {
    checkPagePermission('cases', 'EXCMCaseCreate')
  },

  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ]),
    mobileView () {
      return this.$store.state.mobileView
    }
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXCMCaseList', params: { id: created['@id'] } })
    }
  },
  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm (e, button = false) {
      if (button === true) {
        if (this.item.contractorUserData === '') {
          this.item.contractorUserData = null
        }
        if (this.item.partnerUserData === '') {
          this.item.partnerUserData = null
        }
        this.create(this.item)
      }
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
